/*eslint-disable*/
// @ts-nocheck
import React, { useState, useRef, useEffect } from "react";
import { Breadcrumbs, IconButton, Typography, Button, Checkbox } from "@mui/material";

import DefaultTemplate from "@/templates/DefaultTemplate/DefaultTemplate";
import { PageHeader, PageContent, DynamicFilter, CustomDateFilter, LoadingSpinner, RenderIf } from "@adl/smart-ui-library";
import { useAppDispatch } from "@/hooks";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import { setSelectedTasks } from "@/redux/tasksSlice";
import { setSelectedCase, setSelectedDocument } from "@/redux/casesSlice";
import { useMsal } from "@azure/msal-react";
import Notifications from "@/components/Notifications";

import MyUploads from "../../components/CaseProfileWrapper/DocumentList/MyUploads";
import VaultIcon from "@/components/VaultIcon";
import VaultTextLogo from "@/components/VaultTextLogo";
import { useNavigate } from "react-router-dom";
import * as Styled from "./MyTasksWrapper.styles";

import type { FilePond as FilePondInstance } from "filepond";
import "filepond/dist/filepond.min.css";
import { Box, TextField, FormControlLabel, } from "@mui/material";
import axiosInstance from "../../axiosConfig";


const NonPCode = () => {
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);

  const filePondRef = useRef<ReactFilePond | null>(null);
  const [files, setFiles] = React.useState<any[]>([]);

  const [caseDocuments, setCaseDocuments] = useState([]);
  const [currentFileIndex] = React.useState<number>(0);
  const [facets, setFacets] = React.useState<any | null>(null)
  const [filters, setFilters] = useState({});
  const [onDelete, setOnDelete] = useState(false);
  const [searchString, setSearchString] = useState<string>("");
  const [myUpload, setMyUpload] = useState(true);
  const [pagination, setPagination] = useState([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const navigateToHome = () => {
    appDispatch(setSelectedTasks(false));
    appDispatch(setSelectedCase(null));
    appDispatch(setSelectedDocument(null));
    navigate(`/`);
  };
  const { instance } = useMsal();

  const onLogout = () => {
    instance.logout();
  };

  const onTaskBtnClick = () => {
    appDispatch(setSelectedTasks([]));
    navigate(`/tasks`);
  };
  const onNonBtnClick = () => {
    appDispatch(setSelectedTasks([]));
    navigate(`/non-p-code`);
  };

  const onSearch = async () => {
    setIsLoading(true)
    try {
      const url = myUpload ? "documents/nonpcode/search/me" : "documents/nonpcode/search"
      const response = await axiosInstance.post(url, {
        "skip": skip,
        "top": 10,
        "fileNameOriginal": searchString,
        ...filters

      });
      console.log(response)
      setFacets(response.data.facets)

      setCaseDocuments(response.data.results)
      setPagination(response.data.pagination)
      setIsLoading(false)

    } catch (error: any) {
      setError(true);
    }

  };

  const onSelectDocument = (data) => {

  };

  const handleDelete = async (id) => {
    try {
      const response = await axiosInstance.delete(`documents/nonpcode/${id}`);
      console.log(response)
      setOnDelete(true)
    } catch (error: any) {
      setError(true);
    }

  };


  const [isRefresh, setIsRefresh] = React.useState<boolean>(false);


  const [skip, setSkip] = React.useState(0);

  const filterDates = (filters, param?: string): any => {
    const target = param || 'date'
    const date = filters.find((item) => item.type === target)
    return date && (date?.param as { startDate: string | undefined; endDate: string | undefined })
  }
  const onUpdatePagination = (skip: number) => {
    setSkip(skip);
  };

  const handleRadio = (e) => {
    setMyUpload(!myUpload);
    sessionStorage.setItem('uploadOwner', !myUpload)

    console.log(myUpload)
  };
  const onFilterUpdate = (e) => {
    console.log(e)
    if (e.type === 'uploadDate') {
      setFilters((prev) => ({
        ...prev,
        'uploadDateFrom': e.filters[0]?.param.startDate,
        'uploadDateTo': e.filters[0]?.param.endDate,
      }));
    } else
      setFilters((prev) => ({
        ...prev,
        [e.type]: e.filters[0]?.value,
      }));
  };
  const formatFacets = (facets) => {
    return facets?.map((item) => {
      return {
        label: item.name,
        value: item.id,
        param: item.id || item.name
      }
    })
  }
  useEffect(() => {
    if (files.length > 0 && currentFileIndex < files.length) {
      setModalOpen(true);
      //loadMetaData();
    }
  }, [files, currentFileIndex]);
  useEffect(() => {
    console.log(filters)
    onSearch()
  }, [filters, myUpload, skip, onDelete]);

  const accessLevelName = sessionStorage.getItem('accessLevelName') || '';

  return (
    <DefaultTemplate paddingTop={200}>
      <>
        <PageHeader
          logo={
            <VaultIcon width={40} height={40} handleClick={navigateToHome} />
          }
          navigation={
            <>
              <Notifications />
              {accessLevelName !== 'NoAccess' &&
                <Button data-testid="tasks-button" onClick={onNonBtnClick}>
                  Non-P-Code Documents
                </Button>
              }
              <Button onClick={onTaskBtnClick}>Tasks</Button>
              <Button onClick={onLogout}>Logout</Button>
            </>
          }
          subHeader={
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<NavigateNextIcon fontSize="small" />}
            >
              <IconButton onClick={navigateToHome}>
                <HomeOutlinedIcon />
              </IconButton>
              <Typography color="text.primary">Non-P-Code Documents</Typography>
            </Breadcrumbs>
          }
        >
          <VaultTextLogo />
        </PageHeader>

        <Styled.MyTasksWrapper>

          <Styled.MyTasksWrapperLeft id="document-profile-left">
            <div style={{ display: 'flex', width: '100%', gap: '280px' }}>
              <Box sx={{ display: "flex", gap: "10px" }}>
                <TextField
                  label="Search"
                  data-testid="search-input"
                  sx={{
                    minWidth: 300,
                    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                      backgroundColor: "white",
                      paddingRight: "8px",
                    },
                  }}
                  onChange={(e) => {
                    setSearchString(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && searchString !== "") {
                      onSearch();
                    }
                  }}
                  value={searchString}

                />

                <Button
                  size="small"
                  variant="contained"
                  disableElevation
                  disabled={!searchString}
                  data-testid="search-button"
                  onClick={onSearch}

                >
                  Search
                </Button>

              </Box>
              <Button
                variant="contained"
                size="small"
                disabled={accessLevelName === 'NoAccess'}
                disableElevation
                onClick={() => {
                  appDispatch(setSelectedDocument(null));

                  navigate(`/upload`);


                }}
                sx={{ width: "15%" }}
              >
                +  Upload Document
              </Button>
            </div>


            <div style={{ width: '100%', display: 'flex' }}>
              <FormControlLabel value={myUpload} control={<Checkbox checked={myUpload} value="true" onChange={handleRadio} />} label="My Uploads" />
              <DynamicFilter source={formatFacets(facets?.categories)} multiple type="categoryId" title="Document Category" onFilterUpdate={(e) => onFilterUpdate(e)} />
              <DynamicFilter source={formatFacets(facets?.practices)} multiple type="practiceId" title="Functional Practice" onFilterUpdate={(e) => onFilterUpdate(e)} />
              <DynamicFilter source={formatFacets(facets?.industries)} multiple type="industryId" title="Account Industry" onFilterUpdate={(e) => onFilterUpdate(e)} />
              <CustomDateFilter title="Upload date" type="uploadDate" onFilterUpdate={(e) => onFilterUpdate(e)} />

            </div>

            {caseDocuments.length > 0 ?
              (
                <Typography variant="body1">
                  Showing {(pagination?.currentPage - 1) * 10 + 1} to {Math.min(pagination?.currentPage * 10, pagination?.total)} of {pagination?.total}{' '}
                  results
                </Typography>
              ) :
              <Typography variant="body1">
                No results found
              </Typography>

            }
            <PageContent>

              <RenderIf isTrue={isLoading}>
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    left: 0,
                    bottom: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 299,
                    borderRadius: "10px",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <LoadingSpinner />
                </Box>
              </RenderIf>
              {caseDocuments.length > 0 &&

                <MyUploads
                  title={myUpload}
                  data={caseDocuments}
                  onUpdate={onUpdatePagination}
                  onDeleteFile={(id) => handleDelete(id)}
                  onSelectDocument={onSelectDocument}
                  isRefresh={isRefresh}
                  pagination={pagination}
                />

              }

            </PageContent>
          </Styled.MyTasksWrapperLeft>
        </Styled.MyTasksWrapper>


      </>
      <div style={{ marginBottom: '300px' }}></div>

    </DefaultTemplate>
  );
};

export default NonPCode;
